import { CheckIndexedDBIsSupport } from "../../../IndexedDB/tabIndexedDB";
import { SetMerchantChannel } from "../../../broadcastChannel/merchantChannel";
import { CheckBroadcastIsSupport } from "../../../broadcastChannel/tabChannel";
import { BroadcastReCreateTab, SetUserChannel } from "../../../broadcastChannel/userChannel";
import Enums from "../../../enums/enums";
import userInfo from "../../../function/userInfo";
import mainHelper from "../../../helper/mainHelper";
import { SocketConnect } from "../../../helper/notificationHelper";
import shareHelper from "../../../helper/shareHelper";
import { ClearTabFromLocalStorage, InsertTabIdToTabDB, UpdateTabMerchantId } from "../../../helper/tabHelper";
import userHelper from "../../../helper/userHelper";
import i18n from "../../../locales/i18n";
import router from "../../../router";
import * as api from "../../../service/ApiSevice";
import { analytics, event } from "../../../service/analytics/analytics";
import merchantFacade from "../../../service/merchant/merchantFacade";
import userFacade from "../../../service/user/userFacade";
import store from "../../baseController";
export const actions = {
  RemoveCookiesToken({ state, commit }) {
    userInfo.RemoveCookiesToken();
  },
  clean_login({ state, commit }) {
    analytics.emitEvent(event.action.unidentify);
    return api.UserService.DoGetNewAccessTokenByRefreshToken().then((res) => {
      if (res.status.IsSuccess()) {
        let idToken = res.data.id_token;
        let userId = state.userModel.userId.PeakEncryption();
        return api.UserService.DoRevokeToken(idToken, userId).then((resRevokeToken) => {
          commit("MutationSetLoginstatus", Enums.LoadingStatusType.None);
          userInfo.RemoveCookiesToken();
          sessionStorage.removeItem("emi");
          return resRevokeToken;
        });
      } else {
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.None);
        userInfo.RemoveCookiesToken();
        sessionStorage.removeItem("emi");
        return res;
      }
    });
  },
  updateEmi({ commit }, message) {
    commit("MtUpdateEmi", message);
  },
  login_email({ commit, state }, message) {
    let encpw = message.password;
    if (message.userType == Enums.userType.email) {
      encpw = shareHelper.CreateToken(message.password);
    }
    commit("MutationSetLoginstatus", Enums.LoadingStatusType.Loading);
    let source = Enums.ActivityLogSource.PEAK_Experience;
    api.UserService.DoGetAccessToken(message.username, encpw, message.userType, source).then((resAccessToken) => {
      if (resAccessToken.status.IsSuccess()) {
        const responseCode = resAccessToken.data.response_code
          ? resAccessToken.data.response_code
          : Enums.HttpStatusCode.OK;

        analytics.emitEvent(event.submit.login, {
          language: i18n.locale,
          loginFormProperties: message,
          succeeded: responseCode.IsSuccess(),
        });
        if (responseCode.IsSuccess()) {
          //check KeepLogin
          if (message.keepLogin) {
            userInfo.SetCookiesKeepLogin();
            userInfo.SetCookiesAccessToken(resAccessToken.data.access_token);
            userInfo.SetCookiesRefreshToken(resAccessToken.data.refresh_token, true);
          } else {
            userInfo.SetCookiesAccessToken(resAccessToken.data.access_token);
            userInfo.SetCookiesRefreshToken(resAccessToken.data.refresh_token);
          }

          api.UserService.DoGetUserInfoByUserId().then(async (resUser) => {
            if (resUser.status.IsSuccess()) {
              analytics.emitEvent(event.action.identify, resUser.data.userInfo);
              const userModel = userHelper.ConvertToUserModel(resUser.data.userInfo);
              commit("loginSuccess", userModel);
              commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
              ClearTabFromLocalStorage();
              if (message.register) {
                router.push({ name: "welcome" });
              } else {
                const lastUrl = mainHelper.GetLastUrl();
                if (lastUrl) {
                  mainHelper.DeleteLastUrl();
                  window.location.href = lastUrl;
                } else {
                  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                    await InsertTabIdToTabDB();
                    SetUserChannel(userModel.userId);
                    BroadcastReCreateTab();
                  }
                  SocketConnect();
                  router.push({ name: "selectlist" });
                }
              }
            }
          });
        } else {
          let loginStatus = Enums.LoadingStatusType.Failed;

          if (message.userType == Enums.userType.google && responseCode === Enums.HttpStatusCode.Moved) {
            store.dispatch("SetAlertMessage", {
              alertMessage: i18n.t("Alert_Login_Google_Fail"),
              typeMessage: Enums.TypeComponentNoti.error,
            });
            router.push({ name: "register" });
            loginStatus = Enums.LoadingStatusType.None;
          }
          commit("MutationSetLoginstatus", loginStatus);
          userInfo.RemoveCookiesToken();
        }
      } else {
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.Failed);
        userInfo.RemoveCookiesToken();
        analytics.emitEvent(event.submit.login, {
          language: i18n.locale,
          loginFormProperties: message,
          succeeded: false,
        });
      }
    });
  },
  authorizeModels({ commit, state }) {
    let refresh_token = userInfo.GetRefreshToken();
    if (refresh_token) {
      const userInfo = state.userModel;
      if (userInfo == null) {
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.Loading);
        api.UserService.DoGetUserInfoByUserId().then(async (resUser) => {
          if (resUser.status.IsSuccess()) {
            analytics.emitEvent(event.action.identify, resUser.data.userInfo);
            const userModel = userHelper.ConvertToUserModel(resUser.data.userInfo);
            commit("loginSuccess", userModel);
            ClearTabFromLocalStorage();
            if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
              await InsertTabIdToTabDB();
              SetUserChannel(userModel.userId);
            }
            SocketConnect();
            commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
          } else {
            router.push("/SessionExpire");
          }
        });
      }
    } else {
      router.push("/logout");
    }
  },
  DoGetUserDetailForDisplay({ commit, state }, userIdList) {
    if (state.otherUserListLoadingStatus !== Enums.LoadingStatusType.Loading) {
      state.otherUserListLoadingStatus = Enums.LoadingStatusType.Loading;
      api.UserService.DoGetUserDetailForDisplay(userIdList).then((res) => {
        const userDetailList = userFacade.ConvertToUserDetailList(res.data.userDetailList);
        commit("MutationUserDetailForDisplay", userDetailList);
        state.otherUserListLoadingStatus = Enums.LoadingStatusType.Success;
      });
    }
  },
  DoGetAllUserDetailForDisplayByMerchantId({ commit, state }) {
    if (state.userListInMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      state.userListInMerchantLoadingStatus = Enums.LoadingStatusType.Loading;
      api.UserService.DoGetAllUserDetailListForDisplayByMerchantId().then((res) => {
        const userDetailList = userFacade.ConvertToUserDetailList(res.data.userDetailList);

        commit("MutationAllUserDetailForDisplayByMerchantId", userDetailList);
        state.userListInMerchantLoadingStatus = Enums.LoadingStatusType.Success;
      });
    }
  },
  DoGetMerchantList({ commit, state }) {
    if (state.merchantListLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetMerchantListLoadingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.MerchantService.DoGetMerchantListByUserId().then((resMerchant) => {
        if (resMerchant.status.IsSuccess()) {
          const merchantList = merchantFacade.ConvertToMerchantList(resMerchant.data.merchantList);
          const demoOrganize = merchantList.find((x) => x.isSample);
          commit("MutationSetDemoOrganize", demoOrganize ? demoOrganize : null);
          commit("MutationSetMerchantList", merchantList);
          commit("MutationSetMerchantListLoadingStatus", Enums.LoadingStatusType.Success);
          store.dispatch("IsLoading", false);
        }
      });
    }
  },
  DoGetAccessToken({ commit, state }, userName) {
    api.UserService.DoGetAccessToken(userName)
      .then((res) => {
        if (res.status.IsSuccess()) {
          const keepLogin = userInfo.GetKeepLogin();
          userInfo.SetCookiesAccessToken(res.data.access_token);
          userInfo.SetCookiesRefreshToken(res.data.refresh_token, keepLogin);
        } else {
          router.push("/logout");
        }
      })
      .catch((err) => {});
  },
  DoGetNewAccessTokenByRefreshToken({ commit, state }) {
    return new Promise((resolve) => {
      api.UserService.DoGetNewAccessTokenByRefreshToken().then((res) => {
        if (res.status.IsSuccess()) {
          const keepLogin = userInfo.GetKeepLogin();
          userInfo.SetCookiesAccessToken(res.data.access_token);
          userInfo.SetCookiesRefreshToken(res.data.refresh_token, keepLogin);
          resolve(true);
        } else {
          location.href = `${window.location.origin}/SessionExpire`;
          resolve(false);
        }
      });
    });
  },
  DoRefreshMerchantList({ commit, state }) {
    return api.UserService.DoRefreshMerchantList().then((res) => {
      if (res.status.IsSuccess()) {
        return true;
      } else {
        router.push("/SessionExpire");
        return false;
      }
    });
  },
  DoGetUserInfoByUserId({ commit, state }) {
    store.dispatch("IsLoading", true);
    commit("MutationSetGetUserInfoByUserIdLoadingStatus", Enums.LoadingStatusType.Loading);
    api.UserService.DoGetUserInfoByUserId().then((resUser) => {
      if (resUser.status.IsSuccess()) {
        const userModel = userHelper.ConvertToUserModel(resUser.data.userInfo);
        commit("loginSuccess", userModel);
        commit("MutationSetLoginstatus", Enums.LoadingStatusType.Success);
      }
      store.dispatch("IsLoading", false);
      commit("MutationSetGetUserInfoByUserIdLoadingStatus", Enums.LoadingStatusType.Success);
    });
  },
  DoSelectMerchant({ commit, state }, input) {
    if (state.selectMerchantLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsSetSelectMerchantLodingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.MerchantService.DoGetSelectedMerchant(input.merchantId, input.isUseMainDatabase).then((resMerchant) => {
        if (resMerchant.status.IsSuccess() && resMerchant.data.responseCode.IsSuccess()) {
          store.dispatch("IsLoading", false);
          const selectMerchant = userHelper.GetSelectedMerchant(resMerchant.data.merchant);
          if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
            SetMerchantChannel(selectMerchant.merchantId);
            UpdateTabMerchantId(selectMerchant.merchantId);
          }
          commit("MutationsSelectMerchant", selectMerchant);
        } else {
          commit("MutationsSelectMerchant", null);
        }
        commit("MutationsSetSelectMerchantLodingStatus", Enums.LoadingStatusType.Success);
      });
    }
  },
  DoGet2ndLogin({ commit, state }) {
    if (state.get2ndLoginLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsGet2ndLoginLodingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.UserService.DoGet2ndLogin().then((res) => {
        if (res.status.IsSuccess()) {
          store.dispatch("IsLoading", false);
          commit("MutationsGet2ndLogin", res.data.is2ndLogin);
          commit("MutationsGet2ndLoginLodingStatus", Enums.LoadingStatusType.Success);
        }
      });
    }
  },
  DoSet2ndLogin({ commit, state }) {
    if (state.set2ndLoginLodingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationsSet2ndLoginLodingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.UserService.DoSet2ndLogin().then((res) => {
        if (res.status.IsSuccess()) {
          store.dispatch("IsLoading", false);
          commit("MutationsSet2ndLoginLodingStatus", Enums.LoadingStatusType.Success);
        }
      });
    }
  },
  DoGetRefreshTokenExpiration({ commit, state }) {
    if (state.refreshTokenExpirationLodingStatus !== Enums.LoadingStatusType.Loading) {
      let refreshToken = userInfo.GetRefreshToken();
      if (refreshToken) {
        commit("MutationsSetRefreshTokenExpirationLodingStatus", Enums.LoadingStatusType.Loading);
        store.dispatch("IsLoading", true);
        api.UserService.DoGetRefreshTokenExpiration().then((res) => {
          if (res.status.IsSuccess()) {
            const lastUrl = mainHelper.GetLastUrl();
            if (lastUrl) {
              mainHelper.DeleteLastUrl();
              window.location.href = lastUrl;
            } else {
              router.push({ name: "selectlist" });
            }
          } else {
            store.dispatch("RemoveCookiesToken");
          }
          store.dispatch("IsLoading", false);
          commit("MutationsSetRefreshTokenExpirationLodingStatus", Enums.LoadingStatusType.Success);
        });
      } else {
        store.dispatch("RemoveCookiesToken");
      }
    }
  },
  DoGetFavoriteMerchant({ commit, state }) {
    if (state.getFavoriteMerchantListLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoGetFavoriteMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetFavoriteMerchantList", res.data.merchantFavorite);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.Success);
      });
    }
  },
  DoUpdateFavoriteMerchant({ commit, state }, merchantId) {
    if (state.updateFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetUpdateFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoUpdateFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetUpdateFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.None);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
      });
    }
  },
  DoDeleteFavoriteMerchant({ commit, state }, merchantId) {
    if (state.deleteFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetDeleteFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoDeleteFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationSetDeleteFavoriteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationSetFavoriteMerchantListLoadingStatus", Enums.LoadingStatusType.None);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
      });
    }
  },
  DoDeleteMerchant({ commit, state }, merchantName) {
    if (state.deleteFavoriteMerchantLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationSetDeleteMerchantLoadingStatus", Enums.LoadingStatusType.Loading);
      store.dispatch("IsLoading", true);
      api.MerchantService.DoDeleteMerchant(merchantName).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          router.push({ name: "selectlist" });
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetDeleteMerchantLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("IsLoading", false);
      });
    }
  },
  DoCheckIsCreatedMerchantNotSample({ commit, state }, isUseMainDatabase = false) {
    if (state.checkIsCreatedMerchantNotSampleLoadingStatus !== Enums.LoadingStatusType.Loading) {
      store.dispatch("IsLoading", true);
      commit("MutationSetCheckIsCreatedMerchantNotSampleLoadingStatus", Enums.LoadingStatusType.Loading);
      api.MerchantService.DoCheckIsCreatedMerchantNotSample(isUseMainDatabase).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          commit("MutationSetIsCreatedMerchantNotSample", res.data.isCreatedMerchantNotSample);
        } else {
          const alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
        }
        commit("MutationSetCheckIsCreatedMerchantNotSampleLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("IsLoading", false);
      });
    }
  },
  DoGetMerchantModelById({ commit, state }, merchantId) {
    return new Promise((resolve) => {
      commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Loading);
      let merchantModelOnLocal = null;
      merchantModelOnLocal = state.merchantModelListForMap.get(merchantId);

      if (merchantModelOnLocal) {
        setTimeout(() => {
          commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Success);
          resolve({ ...merchantModelOnLocal });
        }, 0);
      } else {
        api.MerchantService.DoGetSelectedMerchant(merchantId, false).then((resMerchant) => {
          if (resMerchant.status.IsSuccess() && resMerchant.data.responseCode.IsSuccess()) {
            store.dispatch("IsLoading", false);
            const merchant = userHelper.GetSelectedMerchant(resMerchant.data.merchant);
            commit("MutationSetMerchantModelList", merchant);
            resolve({ ...merchant });
          } else {
            resolve(null);
          }
          commit("MutationSetMerchantModelByIdLoadingStatus", Enums.LoadingStatusType.Success);
        });
      }
    });
  },
  DoIntrospectAccessToken({ commit, state }) {
    return new Promise((resolve) => {
      api.UserService.DoIntrospectAccessToken().then((res) => {
        if (res.status.IsSuccess()) {
          resolve(res.data.active);
        } else {
          resolve(false);
        }
      });
    });
  },
  DoUpdateAccessToken({ commit, state }) {
    return new Promise((resolve) => {
      api.NotificationService.DoUpdateAccessToken().then((res) => {
        if (res.status.IsSuccess()) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
};
